<mat-form-field appearance="outline" class="template-selector">
  <mat-label>Search Template</mat-label>
  @if (isLoading()) {
    <mat-spinner matPrefix [diameter]="20"></mat-spinner>
  }
  <input
    type="text"
    placeholder="Template Name"
    matInput
    [formControl]="control"
    [matAutocomplete]="auto"
    (click)="onInputClick()"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="onSelected($event.option.value)"
  >
    @for (template of templates(); track template.id) {
      <mat-option [value]="template">
        {{ template.templateName }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
